import { Carousel } from 'src/core/components';
import { hoc } from 'src/core/utils';
import { Product } from './product';
import { useProductsCarouselProps } from './products-carousel.props';
import styles from './products-carousel.module.scss';

/**
 * <ProductsCarousel />
 */
const ProductsCarousel = hoc(
  useProductsCarouselProps,
  ({ width, products, locale, page }) => (
    <div className={styles.products_carousel} id='tastes'>
      <div className={styles.wrapper}>
        <h2 className={styles.title}>{page.productsCarousel.title[locale]}</h2>
        <p className={styles.text}>{page.productsCarousel.text[locale]}</p>
      </div>
      <Carousel
      // containerClassName={styles.carousel_container}
      // className={styles.carousel}
      // arrowsTheme='dark'
      // arrowSize='sm'
      // slidesToShow={width > 1150 ? 3 : 1}
      // centerMode={width <= 1150}
      // infinite
      // centerPadding='30px'
      // arrowSlider
      // arrows={width > 1250}
      // isArrowsOutside
      // variableWidth={width <= 1150}
      >
        {products.map((product, index) => (
          <Product
            key={index}
            index={index}
            // @ts-ignore
            product={product}
            locale={locale}
            productsLength={products.length}
          />
        ))}
      </Carousel>
    </div>
  )
);

export { ProductsCarousel };
